import { TextWidth, TextWidthExtended } from '@ta-interaktiv/react-disco-grid'
import React from 'react'
import styled from 'styled-components'

export const Trick = () => {
    console.log("TRICK")
  return (
    <>
      {/* <TextWidth>
        <Title>
          Neuronale Netze lassen sich leicht durch seltsame Posen vertrauter
          Objekte täuschen
        </Title>
        <Lead>
          In einer Studie der Auburn Universität wurde untersucht, wie anfällig Bilderkennungs-KIs auf ungewöhnliche Posen von Objekten in Bildern sind. Die Algorithmen sind sich dabei oft sehr sicher,zum Teil bis zu 100%, dass ihre Einschätzung richtig ist, obwohl sie vollkommen daneben liegen. 
        </Lead>
      </TextWidth> */}
      <TextWidthExtended>
        <StyledTrick>
          <ImageContainer>
            <img src={require('./images/trick_3_1.jpg')} />
            <div>
              Schulbus<span>100%</span>
            </div>
          </ImageContainer>
          <ImageContainer>
            <img src={require('./images/trick_3_2.jpg')} />
            <div>
              Kehrrichtauto<span>99%</span>
            </div>
          </ImageContainer>
          <ImageContainer>
            <img src={require('./images/trick_3_3.jpg')} />
            <div>
              Boxsack<span>100%</span>
            </div>
          </ImageContainer>
          <ImageContainer>
            <img src={require('./images/trick_3_4.jpg')} />
            <div>
              Schneepflug<span>92%</span>
            </div>
          </ImageContainer>
          <ImageContainer>
            <img src={require('./images/trick_2_1.jpg')} />
            <div>
              Motorroller<span>99%</span>
            </div>
          </ImageContainer>
          <ImageContainer>
            <img src={require('./images/trick_2_2.jpg')} />
            <div>
              Fallschirm<span>100%</span>
            </div>
          </ImageContainer>
          <ImageContainer>
            <img src={require('./images/trick_2_3.jpg')} />
            <div>
              Rennbob<span>100%</span>
            </div>
          </ImageContainer>
          <ImageContainer>
            <img src={require('./images/trick_2_4.jpg')} />
            <div>
              Fallschirm<span>54%</span>
            </div>
          </ImageContainer>
          <ImageContainer>
            <img src={require('./images/trick_1_1.jpg')} />
            <div>
              Feuerwehrfahrzeug<span>99%</span>
            </div>
          </ImageContainer>
          <ImageContainer>
            <img src={require('./images/trick_1_2.jpg')} />
            <div>
              Schulbus<span>98%</span>
            </div>
          </ImageContainer>
          <ImageContainer>
            <img src={require('./images/trick_1_3.jpg')} />
            <div>
              Feuerwehrboot<span>98%</span>
            </div>
          </ImageContainer>
          <ImageContainer>
            <img src={require('./images/trick_1_4.jpg')} />
            <div>
              Rennbob<span>79%</span>
            </div>
          </ImageContainer>
        </StyledTrick>
      </TextWidthExtended>
      <TextWidth>
        <Source>
          Quelle:{' '}
          <a href=' http://s.anhnguyen.me/190403__strike_with_a_pose_alcorn_et_al_2019.pdf'>
            Neural Networks Are Easily Fooled by Strange Poses of Familiar
            Objects, Michael A. Alcorn et al.
          </a>
        </Source>
      </TextWidth>
    </>
  )
}

const Lead = styled.div`
  flex: 0 0 100%;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.6em;
  margin-bottom: 15px;
  font-family: var(--font-serif);
`
const Title = styled.div`
  flex: 0 0 100%;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3em;
  margin-bottom: 15px;
  font-family: var(--font-sans-serif);
`
const Source = styled.div`
  flex: 0 0 100%;
  font-size: 12px;
  color: var(--gray-3);
  font-family: var(--font-sans-serif);
  margin-bottom: 60px;
  line-height: 1.4em;
  margin-bottom: 60px;
  a {
    color: var(--gray-3);
    text-decoration: underline;
  }
`
const StyledTrick = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
`
const ImageContainer = styled.div`
  flex: 0 0 calc(25% - 5px);
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
  @media only screen and (max-width: 711px) {
    flex: 0 0 calc(50% - 5px);
  }
  img {
    flex: 0 0 100%;
    max-width: 100%;
  }
  div {
    font-family: var(--font-sans-serif);
    font-size: 15px;
    line-height: 1.1em;
    flex: 0 0 50%;
    font-weight: 700;
    margin-top: 6px;
    span {
      font-weight: 300;
      font-size: 12px;
      display: inline-block;
      width: 100%;
    }
  }
`
